module.exports = __webpack_public_path__ + "img/trip_sendai04.c6041a36.jpg";